module.exports = __webpack_public_path__ + "static/media/baseline-help-24px-white.b567670c.svg";